import React, { useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Styles/FacultySupport.css";
import { Link } from "react-router-dom";
import Loader from "../../Components/Loader";

function StudentSupport() {
    const [ticketData, setTicketData] = useState({ subject: "", description: "", mobile: "" });
    const [loading, setLoading] = useState(false);

    const handleTicketSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("authToken");
        setLoading(true);

        try {
            const response = await axios.post(
                "https://api.uniums.com/api/tickets/student-create-ticket",
                ticketData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            toast.success("Ticket generated successfully!");
            setTicketData({ subject: "", description: "", mobile: "" });
        } catch (error) {
            console.error("Error generating ticket:", error);
            toast.error("Failed to generate ticket.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="support-container">
            <div className="support-card">
                <h1>Welcome to UniUms Support</h1>
                <p className="ticket_para">Your one-stop solution for faculty support</p>

                <section className="about">
                    <h2>About UniUms</h2>
                    <p>
                        UniUms is dedicated to providing high-quality support to faculty, students, and administrators from various colleges. We streamline communication and ensure that everyone has access to the resources and assistance they need. Whether you're facing technical issues or have questions, UniUms is here to help.
                    </p>
                </section>
                <section className="ticket-form">
                    <h2>Generate Support Ticket</h2>
                    <form onSubmit={handleTicketSubmit}>
                        <div>
                            <label>Subject <span>*</span></label>
                            <input
                                type="text"
                                value={ticketData.subject}
                                onChange={(e) => setTicketData({ ...ticketData, subject: e.target.value })}
                                required
                            />
                        </div>
                        <div>
                            <label>Description <span>*</span></label>
                            <textarea
                                value={ticketData.description}
                                onChange={(e) => setTicketData({ ...ticketData, description: e.target.value })}
                                required
                            ></textarea>
                        </div>
                        <div>
                            <label>Mobile Number <span>*</span></label>
                            <input
                                type="tel"
                                value={ticketData.mobile}
                                onChange={(e) => setTicketData({ ...ticketData, mobile: e.target.value })}
                                placeholder="Enter your mobile number"
                                pattern="[0-9]{10}"
                                required
                            />
                        </div>
                        <button type="submit">Submit Ticket</button>
                    </form>
                    {loading && <Loader />}
                </section>

                <Link to={'/student-ticket-history'}> Check Ticket History</Link>

                <section className="faq">
                    <h2>Frequently Asked Questions</h2>
                    <div>
                        <h3>How do I generate a support ticket?</h3>
                        <p>Click on the "Generate Support Ticket" section and fill out the form.</p>
                    </div>
                    <div>
                        <h3>How long will it take to resolve my issue?</h3>
                        <p>Our support team strives to resolve issues within 48 hours.</p>
                    </div>
                </section>
            </div>
            <ToastContainer />
        </div>
    );
}

export default StudentSupport;
